import { NavLink } from 'react-router-dom';
import useScrolled from '../hooks/useScrolled';
import ServerStatus from '../middleware/mcstats'; // Importing the player count component
import { MemberCount } from '../middleware/guild'; // Import the MemberCount component from the custom API
import MobileNav from './MobileNav';
import CommandPalette from './CommandPalette';
import CopyIp from './CopyIp';
import { NAV_LINKS } from '../config/nav';
import { EXTERNAL } from '../config/links';
import logo from '../imgs/ISN_Logo.png';
import '../styles/Header.css';

const Header = () => {
    const scrolled = useScrolled();

    return (
        // No wrapping element: a sticky child can only stick within its
        // containing block, and the old .header div was 290px tall, so the nav
        // scrolled away the moment you passed the hero. The div carried no
        // styles of its own. As a fragment the nav's containing block is the
        // document, and it sticks for the whole page.
        <>
        {/* Sticky so the nav stays reachable past the tall hero band, and
            condensed once scrolled so it reads as chrome rather than as part
            of the artwork. */}
        <nav className={`main-nav${scrolled ? ' main-nav--scrolled' : ''}`}>
          <MobileNav />
          <ul className="nav-links">
            {NAV_LINKS.map((link) => (
              <li key={link.to}>
                {/* NavLink applies an `active` class on the matching route. */}
                <NavLink to={link.to}>{link.label}</NavLink>
              </li>
            ))}
          </ul>
          <CommandPalette />
        </nav>
        
        <header className="header-bar">
          
          <div className="header-bar-left">
            <CopyIp />
            <ServerStatus />
          </div>
          <img src={logo} className="Isn-logo" alt="logo" />
          <div className="header-bar-right">
            <div className='Store'>
              <a
                className='Store-btn'
                href={EXTERNAL.store}
                target='_blank'
                rel='noopener noreferrer'
              >
                <div className='Store-content'>
                  <span className='Store-title'>STORE</span>
                  <span className='Store-subtext'>Shop now!</span>
                </div>
                <svg className='Store-icon' xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512">
                  <path d="M253.3 35.1c6.1-11.8 1.5-26.3-10.2-32.4s-26.3-1.5-32.4 10.2L117.6 192 32 192c-17.7 0-32 14.3-32 32s14.3 32 32 32L83.9 463.5C91 492 116.6 512 146 512L430 512c29.4 0 55-20 62.1-48.5L544 256c17.7 0 32-14.3 32-32s-14.3-32-32-32l-85.6 0L365.3 12.9C359.2 1.2 344.7-3.4 332.9 2.7s-16.3 20.6-10.2 32.4L404.3 192l-232.6 0L253.3 35.1zM192 304l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16zm96-16c8.8 0 16 7.2 16 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16zm128 16l0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"/>
                </svg>
              </a>
            </div>

              <div className="Discord-Members">
                  <a href={EXTERNAL.discord} className="discord-link" target="_blank" rel="noopener noreferrer">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512">
                      <path d="M524.5 69.8a1.5 1.5 0 0 0 -.8-.7A485.1 485.1 0 0 0 404.1 32a1.8 1.8 0 0 0 -1.9 .9 337.5 337.5 0 0 0 -14.9 30.6 447.8 447.8 0 0 0 -134.4 0 309.5 309.5 0 0 0 -15.1-30.6 1.9 1.9 0 0 0 -1.9-.9A483.7 483.7 0 0 0 116.1 69.1a1.7 1.7 0 0 0 -.8 .7C39.1 183.7 18.2 294.7 28.4 404.4a2 2 0 0 0 .8 1.4A487.7 487.7 0 0 0 176 479.9a1.9 1.9 0 0 0 2.1-.7A348.2 348.2 0 0 0 208.1 430.4a1.9 1.9 0 0 0 -1-2.6 321.2 321.2 0 0 1 -45.9-21.9 1.9 1.9 0 0 1 -.2-3.1c3.1-2.3 6.2-4.7 9.1-7.1a1.8 1.8 0 0 1 1.9-.3c96.2 43.9 200.4 43.9 295.5 0a1.8 1.8 0 0 1 1.9 .2c2.9 2.4 6 4.9 9.1 7.2a1.9 1.9 0 0 1 -.2 3.1 301.4 301.4 0 0 1 -45.9 21.8 1.9 1.9 0 0 0 -1 2.6 391.1 391.1 0 0 0 30 48.8 1.9 1.9 0 0 0 2.1 .7A486 486 0 0 0 610.7 405.7a1.9 1.9 0 0 0 .8-1.4C623.7 277.6 590.9 167.5 524.5 69.8zM222.5 337.6c-29 0-52.8-26.6-52.8-59.2S193.1 219.1 222.5 219.1c29.7 0 53.3 26.8 52.8 59.2C275.3 311 251.9 337.6 222.5 337.6zm195.4 0c-29 0-52.8-26.6-52.8-59.2S388.4 219.1 417.9 219.1c29.7 0 53.3 26.8 52.8 59.2C470.7 311 447.5 337.6 417.9 337.6z"/>
                      </svg>
                    </a>
                  <span> Join <strong><MemberCount /></strong> other people!</span>
              </div>
              </div>
          </header>
          </>
        );
    }
export default Header;
